import React from 'react';
import { object, arrayOf } from 'prop-types';
import styled from 'styled-components';

import Navbar from './NavbarContainer';
import LandingHeader from './LandingHeader';
import Reasons from './ReasonBox';
import Products from './PlanBox';
import Benefits from './BenefitBoxContainer';
import Testimonials from './TestimonialBox';
import QuestionsBox from '../../core/components/questions/QuestionsBox';
import CommunicationBox from './CommunicationBoxContainer';
import ContentSeparator from './ContentSeparator';
import GoldHighlightBox from './GoldHighlightBox';

const Container = styled.div`
  width: 100%;
  display: block;
  margin: 0 auto;
`;

const Marketing = ({
  posData, productsData, contentData, navItems,
}) => {
  const {
    headerImage: image, title, subtitle, reasons, benefits, testimonials, questions, telesales, showTelesales, infoDetail: info, message, details, plan, showGoldHighlightBox, goldExplained,
  } = contentData;
  const { parentName } = posData;
  const { subscriptions, subscriptionList } = productsData;

  return (
    <Container>
      <Navbar items={navItems} right sticky />
      <LandingHeader image={image} title={title} subtitle={subtitle} marketing />
      <Reasons reasons={reasons} />
      <Products subscriptions={subscriptions} info={info} message={message} details={details} title={plan.title} subtitle={plan.subtitle} posName={parentName} showDropdown={subscriptionList.length > 3} />
      {showGoldHighlightBox && <GoldHighlightBox goldExplained={goldExplained} />}
      <CommunicationBox posName={parentName} showIf={showTelesales} telesales={telesales} />
      <ContentSeparator />
      <Benefits benefits={benefits} />
      <ContentSeparator />
      <Testimonials testimonials={testimonials} />
      <QuestionsBox questions={questions} />
    </Container>
  );
};

Marketing.propTypes = {
  posData: object,
  productsData: object,
  contentData: object,
  navItems: arrayOf(object),
};

Marketing.defaultProps = {
  posData: {},
  productsData: {},
  contentData: {},
  navItems: [],
};

export default Marketing;
